import { useIntl } from 'react-intl';
import styles from './OwnerBanner.module.scss';

interface Props {
  editProfileUrl: string;
  refreshPhase: 'refreshing' | 'done';
}

export function OwnerBanner({ editProfileUrl, refreshPhase }: Props) {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      {refreshPhase === 'refreshing' ? (
        <>
          <span className={styles.spinner} aria-hidden="true" />
          <span className={styles.label}>
            {intl.formatMessage({
              id: 'Refreshing your latest changes…',
              defaultMessage: 'Refreshing your latest changes…',
            })}
          </span>
        </>
      ) : (
        <>
          <span className={styles.label}>
            {intl.formatMessage({
              id: 'Need to make some updates?',
              defaultMessage: 'Need to make some updates?',
            })}
          </span>
          <a className={styles.link} href={editProfileUrl}>
            {intl.formatMessage({
              id: 'Edit organizer profile',
              defaultMessage: 'Edit organizer profile',
            })}
          </a>
        </>
      )}
    </div>
  );
}
